<div class="language-picker modal">
  <div class="modal">
    <div class="modal__top">
      <span class="modal__title">{{ 'BREADCRUMBS.LANGUAGES' | i18nextEager | uppercase }}</span>
      <span class="modal__click" (click)="closeDialog()">
        <img src="/assets/icons/close_modal.svg" alt="" />
      </span>
    </div>
    <div class="modal__body language-picker__pickers">
      <div *ngFor="let option of options" class="language-picker__option" (click)="changeLanguage(option)">
        <span [ngClass]="option.id === chosenLanguage ? 'active' : ''">{{ option.name | i18nextEager }}</span>
        <span class="language-picker__option__check">
          <img *ngIf="option.id === chosenLanguage" src="/assets/icons/check.svg" alt="" />
        </span>
      </div>
    </div>
    <div class="modal__footer">
      <button class="secondary" (click)="closeDialog()">{{ 'COMMONS.CANCEL' | i18nextEager }}</button>
      <button (click)="save()">{{ 'COMMONS.SAVE' | i18nextEager }}</button>
    </div>
  </div>
</div>
